import { assignInlineVars } from '@vanilla-extract/dynamic';
import { Element } from '../element';
import { Row } from '../flex';
import { Icon, IconName } from '../icon';
import * as styles from './chatBubble.css';
import { ChatBubbleProps } from './types';

export const ChatBubble = ({
  platform,
  colorCode,
  bubbleType,
  chat,
  text,
  showNickname = true,
}: ChatBubbleProps) => {
  const platformIconName = `CHAT_WIDGET_${platform.toUpperCase()}` as IconName;

  return (
    <div className={styles.bubbleWrapper}>
      {bubbleType === 'chat' ? (
        <Row gap="gap_xs">
          <div className={styles.platformIcon}>
            <Icon name={platformIconName} color="primary" size="16" />
          </div>
          <Element className={styles.messageContent}>
            {showNickname && (
              <>
                <span
                  className={styles.nickname}
                  style={assignInlineVars({ [styles.colorVar]: colorCode })}>
                  {chat.nickname}
                </span>
                <span className={styles.chatText}> : </span>
              </>
            )}
            <span className={styles.chatText}>{chat.text}</span>
          </Element>
        </Row>
      ) : (
        <div className={styles.bubbleNormalText}>{text}</div>
      )}
    </div>
  );
};
